import { Directive, HostListener, Input, ElementRef, OnInit } from '@angular/core';
import { ModalRedirectToService } from 'app/core/modal-redirect-to/modal-redirect-to.service';

@Directive({
  selector: '[cmRedirectTo]',
})
export class RedirectToDirective implements OnInit {

  @Input() cmRedirectTo;

  constructor(
    private modalRedirectService: ModalRedirectToService,
    private el: ElementRef) { }

  ngOnInit() {
    this.el.nativeElement.classList.add('redirect-to');
  }

  @HostListener('click')
  click() {
    this.modalRedirectService.open(this.cmRedirectTo);
  }
}
